.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-width: var(--form-max);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.control {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
  min-width: 0;
}

.chosen {
  overflow: hidden;
  color: var(--graphite);
  font: var(--t-body);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}
